import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faSave, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { getInput } from '../../utils';

class DataTableRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            edit: false,
            data: this.props.data,
            hold: this.props.cols.reduce((memo, { key, type, multiple }) => {
                if (type !== 'select' && multiple) {
                    memo[key] = '';
                }
                return memo;
            }, {}),
            selectAll: false,
        }
    }

    render() {
        let data = this.state.data;
        return <tr key={data.id}>
            <th className={`text-center ${this.state.edit ? 'align-bottom' : ''}`}
                scope='row'>{this.props.sequence}</th>
            {
                this.props.cols.map(col => <td key={col.key}
                    className={`${col.type === 'textarea' ? 'whitespace-prewrap' : ''} ${this.state.edit ? 'align-bottom' : ''}`}>
                    {
                        this.state.edit ?
                            getInput({
                                ...col,
                                name: col.key,
                                value: data[col.key],
                                hold: this.state.hold[col.key],
                                selectAll: this.state.selectAll,
                                onChange: e => {
                                    const el = e.currentTarget;
                                    const change = { data: { ...data }, hold: { ...this.state.hold } };
                                    if (col.multiple) {
                                        change.data[col.key] = [...data[col.key]];
                                        if (col.type === 'select') {
                                            const val = el.dataset.value;
                                            const all = [...this.props.cols.find(c => c.key === col.key).options];
                                            if (val === 'SELECTALL') {
                                                change.data[col.key] = this.state.selectAll ? [] : all;
                                                change.selectAll = !this.state.selectAll;
                                            } else {
                                                const i = data[col.key].indexOf(val);
                                                i === -1 ?
                                                    change.data[col.key].push(val) :
                                                    change.data[col.key].splice(i, 1);
                                                change.selectAll = all.length === change.data[col.key].length;
                                            }
                                        } else {
                                            change.hold[col.key] = col.autoCapitalize ? el.value.toUpperCase() : el.value;
                                        }
                                    } else if (col.autoCapitalize) {
                                        change.data[col.key] = el.value.toUpperCase();
                                        setTimeout(((s, e) => _ => el.setSelectionRange(s, e))(el.selectionStart, el.selectionEnd), 0);
                                    } else {
                                        change.data[col.key] = el.value;
                                    }
                                    this.setState(change);
                                },
                                onKeyPress: e => {
                                    const val = e.currentTarget.value.trim();
                                    if ((e.which === 13 || e.key === 'Enter') && val.length) {
                                        e.preventDefault();
                                        const change = { data: { ...data }, hold: { ...this.state.hold } };
                                        change.data[col.key] = [...data[col.key]];
                                        change.data[col.key].push(val);
                                        change.hold[col.key] = '';
                                        this.setState(change);
                                    }
                                },
                                removeValue: i => {
                                    const change = { data: { ...data }, };
                                    change.data[col.key] = [...data[col.key]];
                                    change.data[col.key].splice(i, 1);
                                    this.setState(change);
                                }
                            }) :
                            col.multiple ? data[col.key].join(', ') : data[col.key]
                    }
                </td>)
            }
            <td className='text-center text-nowrap'>
                <button className='btn btn-sm btn-light py-0'
                    onClick={_ => {
                        if (this.state.edit) {
                            this.props.update(data.id, data);
                        }
                        this.setState({ edit: !this.state.edit });
                    }}>
                    <i><FontAwesomeIcon icon={this.state.edit ? faSave : faEdit} /></i></button>
                <button className='btn btn-sm btn-light py-0 ml-1'
                    onClick={_ => this.props.delete(data.id)}>
                    <i><FontAwesomeIcon icon={faTrash} /></i></button>
            </td>
        </tr>;
    }
}

class DataTable extends Component {
    constructor(props) {
        super(props);
        let data = {}, hold = {};
        this.props.cols.forEach(({ key, type, multiple }) => {
            if (multiple) {
                data[key] = [];
                if (type !== 'select') {
                    hold[key] = '';
                }
            } else {
                data[key] = '';
            }
        });
        this.state = { selectAll: false, data, hold, };
        this.headers = this.headers.bind(this);
        this.addNewRow = this.addNewRow.bind(this);
        this.rows = this.rows.bind(this);
    }

    headers() {
        return <tr className='text-nowrap'>
            <th className='text-center' scope='col'>#</th>
            {
                this.props.cols.map(({ key, label, width, required }) => <th key={key}
                    scope='col'
                    style={{ width }}>
                    {label}
                    {required ? '*' : ''}
                </th>)
            }
            <th scope='col'></th>
        </tr>;
    }

    addNewRow() {
        let data = this.state.data;
        return <tr>
            <th className='text-center align-bottom' scope='row'></th>
            {
                this.props.cols.map(col => <td key={col.key} className='align-bottom'>
                    {
                        getInput({
                            ...col,
                            name: col.key,
                            value: data[col.key],
                            hold: this.state.hold[col.key],
                            selectAll: this.state.selectAll,
                            onChange: e => {
                                const el = e.currentTarget;
                                const change = { data: { ...data }, hold: { ...this.state.hold } };
                                if (col.multiple) {
                                    change.data[col.key] = [...data[col.key]];
                                    if (col.type === 'select') {
                                        const val = el.dataset.value;
                                        const all = [...this.props.cols.find(c => c.key === col.key).options];
                                        if (val === 'SELECTALL') {
                                            change.data[col.key] = this.state.selectAll ? [] : all;
                                            change.selectAll = !this.state.selectAll;
                                        } else {
                                            const i = data[col.key].indexOf(val);
                                            i === -1 ?
                                                change.data[col.key].push(val) :
                                                change.data[col.key].splice(i, 1);
                                            change.selectAll = all.length === change.data[col.key].length;
                                        }
                                    } else {
                                        change.hold[col.key] = col.autoCapitalize ? el.value.toUpperCase() : el.value;
                                    }
                                } else if (col.autoCapitalize) {
                                    change.data[col.key] = el.value.toUpperCase();
                                    setTimeout(((s, e) => _ => el.setSelectionRange(s, e))(el.selectionStart, el.selectionEnd), 0);
                                } else {
                                    change.data[col.key] = el.value;
                                }
                                this.setState(change);
                            },
                            onKeyPress: e => {
                                const val = e.currentTarget.value.trim();
                                if ((e.which === 13 || e.key === 'Enter') && val.length) {
                                    e.preventDefault();
                                    const change = { data: { ...data }, hold: { ...this.state.hold } };
                                    change.data[col.key] = [...data[col.key]];
                                    if (data[col.key].indexOf(val) === -1) {
                                        change.data[col.key].push(val);
                                    }
                                    change.hold[col.key] = '';
                                    this.setState(change);
                                }
                            },
                            removeValue: i => {
                                const change = { data: { ...data }, };
                                change.data[col.key] = [...data[col.key]];
                                change.data[col.key].splice(i, 1);
                                this.setState(change);
                            }
                        })
                    }
                </td>)
            }
            <td className='text-center'>
                <button className='btn btn-sm btn-light py-0'
                    onClick={_ => {
                        const reqErr = this.props.cols.find(({ required, key }) => required && !this.state.data[key]);
                        if (!reqErr) {
                            this.props.save(this.state.data)
                                .done(_ => this.setState({
                                    selectAll: false,
                                    data: this.props.cols.reduce((memo, { key, multiple }) => {
                                        memo[key] = multiple ? [] : '';
                                        return memo;
                                    }, {}),
                                    hold: this.props.cols.reduce((memo, { key, type, multiple }) => {
                                        if (type !== 'select' && multiple) {
                                            memo[key] = '';
                                        }
                                        return memo;
                                    }, {}),
                                }))
                                .fail(_ => null);
                        };
                    }}><i><FontAwesomeIcon icon={faPlus} /></i></button></td>
        </tr>;
    }

    rows() {
        return this.props.rows.map((data, i) =>
            <DataTableRow key={data.id} sequence={i + 1}
                cols={this.props.cols}
                data={data}
                update={this.props.update}
                delete={this.props.delete} />
        );
    }

    render() {
        return <table className='data-table table table-sm table-hover text-light m-0'>
            <thead>
                {
                    this.headers()
                }
            </thead>
            <tbody>
                {
                    this.addNewRow()
                }
                {
                    this.props.rows.length ? this.rows() : <tr>
                        <td className='text-center font-weight-light font-italic h6'
                            colSpan='100%'>No data found.</td>
                    </tr>
                }
            </tbody>
        </table>;
    }
};

export default DataTable;